// extracted by mini-css-extract-plugin
export default {"header":"style--header--494aac","right":"style--right--dadfb5","left":"style--left--aef4f7","center":"style--center--7d6e37"};